import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";
export const organizationDataDatasubject = createCrudVuexModule({
  namespaced: true,
  path: "/data-datasubject",
  options: { localizedFields: ["name", "description", "note"] },
  actions: {
    async save({ dispatch }, { payload, changeInAllHierarchy }) {
      if (payload._id) {
        return dispatch("update", { payload, changeInAllHierarchy });
      } else {
        return dispatch("create", payload);
      }
    },

    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.post(`/data-datasubject`, { item: payload });
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async update({ getters, commit, dispatch }, { payload, changeInAllHierarchy }) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.put(`/data-datasubject`, { item: payload, changeInAllHierarchy });

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/data-datasubject/add-from-library", payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async updateNote({ getters, commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        payload = await dispatch("preparePayload", { editedEntity: {}, form: payload });
        const response = await rest.put(`/data-datasubject/note`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },

  mutations: {},
});

export const organizationDatasourceDatasubject = createCrudVuexModule({
  namespaced: true,
  path: "/datasource-datasubject",

  state: {
    pagination: undefined,
    isLoading: false,
    isUpdating: false,
    recommendations: undefined,
  },

  mutations: {
    pagination: (state, value) => (state.pagination = value),
    isLoading: (state, value) => (state.isLoading = value),
    isUpdating: (state, value) => (state.isUpdating = value),

    recommendations(state, value) {
      state.recommendations = value;
    },
  },
  getters: {
    pagination: (state) => state.pagination,
    isLoading: (state) => state.isLoading,
    isUpdating: (state) => state.isUpdating,

    recommendations(state) {
      return state.recommendations;
    },
  },
  actions: {
    async save({ dispatch }, { payload, changeInAllHierarchy }) {
      if (payload._id) {
        return dispatch("update", { payload, changeInAllHierarchy });
      } else {
        return dispatch("create", payload);
      }
    },

    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.post(`/datasource-datasubject`, { item: payload });
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async update({ getters, commit, dispatch }, { payload, changeInAllHierarchy }) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.put(`/datasource-datasubject`, { item: payload, changeInAllHierarchy });

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async paginateForDatasource({ commit }, payload, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("pagination", undefined);
        }
        const response = await rest.post("/datasource-datasubject/paginate-datasource", payload);
        commit("pagination", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },

    async paginateRecommendation({ commit, rootGetters }, { pagination, level, id }, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        const process = rootGetters["entityBoxes/process"];
        const department = rootGetters["entityBoxes/department"];
        const datasource = rootGetters["entityBoxes/datasource"];
        if (clearStateBeforeRest) {
          commit("recommendations", undefined);
        }

        const response = await rest.post(`/recommendation/paginate/datasource-datasubject`, {
          pagination,
          departmentId: department._id,
          processId: process._id,
          datasourceId: datasource._id,
        });
        commit("recommendations", response.data);
        return response;

        return response;
      } finally {
        commit("isLoading", false);
      }
    },

    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/datasource-datasubject", {
          item: {
            ...payload.libraryItem,
            datasource: payload.datasource,
          },
        });
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async delete({ commit }, { datasourceId, datasubjectId }) {
      return rest.delete(`/datasource-datasubject/${datasourceId}/${datasubjectId}`);
    },
  },
});
